"use strict";

var _defineProperty = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaLoader = exports.useMediaObjectProps = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = __importStar(require("react"));

function getNormalizedURI(uri, _ref) {
  var preferredIPFSGateway = _ref.preferredIPFSGateway;

  if (uri.startsWith("ipfs://")) {
    return uri.replace("ipfs://", preferredIPFSGateway || "https://ipfs.io/ipfs/");
  }

  if (uri.includes("/ipfs/") && preferredIPFSGateway) {
    return "".concat(preferredIPFSGateway).concat(uri.replace(/^.+\/ipfs\//, ""));
  }

  if (uri.startsWith("ar://")) {
    return uri.replace("ar://", "https://arweave.net/");
  }

  return uri;
}

function useMediaObjectProps(_ref2) {
  var uri = _ref2.uri,
      request = _ref2.request,
      a11yIdPrefix = _ref2.a11yIdPrefix,
      getStyles = _ref2.getStyles,
      preferredIPFSGateway = _ref2.preferredIPFSGateway;

  var _react_1$useState = react_1.useState(true),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      loading = _react_1$useState2[0],
      setLoading = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      error = _react_1$useState4[0],
      setError = _react_1$useState4[1];

  return {
    loading: loading,
    error: error,
    props: _objectSpread({
      "aria-describedby": "".concat(a11yIdPrefix, "description"),
      alt: request.metadata.name || request.metadata.description,
      onLoad: function onLoad() {
        return setLoading(false);
      },
      // TODO(iain): Update Error
      onError: function onError() {
        return setError("Error loading");
      },
      src: uri ? getNormalizedURI(uri, {
        preferredIPFSGateway: preferredIPFSGateway
      }) : uri
    }, getStyles("mediaObject", undefined, {
      mediaLoaded: !loading,
      isFullPage: request.renderingContext === "FULL"
    }))
  };
}

exports.useMediaObjectProps = useMediaObjectProps;

var MediaLoader = function MediaLoader(_ref3) {
  var getStyles = _ref3.getStyles,
      children = _ref3.children,
      loading = _ref3.loading,
      error = _ref3.error;

  if (!loading && !error) {
    return jsx_runtime_1.jsx(react_1.default.Fragment, {
      children: children
    }, void 0);
  }

  if (error) {
    return jsx_runtime_1.jsxs(react_1.default.Fragment, {
      children: [jsx_runtime_1.jsx("span", Object.assign({}, getStyles("mediaObjectMessage"), {
        children: "Error loading content"
      }), void 0), children]
    }, void 0);
  }

  return jsx_runtime_1.jsxs(react_1.default.Fragment, {
    children: [jsx_runtime_1.jsx("span", Object.assign({}, getStyles("mediaLoader"), {
      children: "Loading..."
    }), void 0), children]
  }, void 0);
};

exports.MediaLoader = MediaLoader;